const getBackgroundColorClass = (type) => "bg-".concat(type);
const getColorClass = (type) => "c-".concat(type);
export {
  getBackgroundColorClass,
  getColorClass
};
